import AdbDialog from './src/adb-dialog.vue';

AdbDialog.install = function (Vue) {
  Vue.component(AdbDialog.name, AdbDialog);
};

export default AdbDialog;
